import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
// import IconButton from '@mui/material/IconButton';
// import ShareIcon from '@mui/icons-material/Share';
import { convertEpochTime, getEndpoint, getUrl, showMultipleAuthor, setCmsSeoData, getAuthorCardTwo } from '../../../common/utils';
//import { SocialShareTwo } from "../SocialShareTwo/SocialShareTwo";
import './PodcastTwo.css';
import Tag from "../../Tag/Tag";
//import { URL_PROTOCAL } from '../../Common/Constant';
import { PAGEBUILDER_URLS } from '../../Common/Constant';
import MediaPlayerWrapper from '../MediaPlayerWrapper';
import bcrypt from 'bcryptjs-react';

PodcastTwo.version = 1000;

PodcastTwo.lang = 'en';
PodcastTwo.langs = [
    'en'
];
PodcastTwo.setLang = (lang: any) => {
    PodcastTwo.lang = lang;
}


Object.defineProperty(PodcastTwo, 'name', {
    writable: true,
    value: 'PodcastTwo'
});

export function PodcastTwo(props: any) {

    const { anchorLinksValue, authorCard } = props;
    const [podcastShowData, setPodcastShowData] = useState<any>({});
    // const [view, setView] = useState(false);
    const { showTags, } = props;


    // let REQUEST_HOSTNAME: any = null;
    // if (props && props.REQUEST_HOSTNAME) {
    //     REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    // }

    // let REQUEST_URL: any = null;
    // if (props && props.REQUEST_URL) {
    //     REQUEST_URL = props.REQUEST_URL;
    // }

    const endpoint = getEndpoint(props, "MAIN");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, [authorCard])

    const addExportedData = (object: any) => {
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
            && object.folderId != null && object.folderId != "") {
            props.exportedKeys.pid = object.folderId;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.sectionid !== "undefined"
            && object.id != null && object.id != "") {
            props.exportedKeys.sectionid = object.id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
            && typeof object.authors != "undefined" && object.authors.length > 0) {
            props.exportedKeys.authorid = object.authors[0].id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
            && typeof object.kws != "undefined" && object.kws.length > 0) {
            const names = object.kws.map((item: any) => item.name).join(',');
            props.exportedKeys.tags = names;
        }
    }

    if (endpoint.isSSR && endpoint.SSRDataObj && podcastShowData && Object.keys(podcastShowData).length === 0
        && endpoint.SSRDataObj.items.length > 0) {
        setPodcastShowData(endpoint.SSRDataObj.items[0])
        addExportedData(endpoint.SSRDataObj.items[0])
        setCmsSeoData(props, endpoint.SSRDataObj.items[0], "VideoShow");
    }

    const fetchComponentData = () => {
        let videoUrl = getUrl(props, 0, false, "MAIN", true);
        let headerString = '?' + videoUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(videoUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                setPodcastShowData(val.items[0])
                addExportedData(val.items[0])
                setCmsSeoData(props, val.items[0], "VideoShow");
            })
    }

    // const handleChange = () => {
    //     setView(!view);
    // };

    const showCredits = () => {
        if (!podcastShowData) {
            console.error('podcastShowData is null or undefined');
            return <></>; // Return an empty fragment or some fallback UI
        }

        const { authors = [], pubInfo = {}, ag = [], upd } = podcastShowData;
        const baseDomain = pubInfo ? pubInfo.baseDomain : '';

        let creditComponent = []
        const authorContent = showMultipleAuthor(authors, baseDomain)
        if (props.showAuthorName && authorContent.length != 0) {
            creditComponent.push(authorContent)
        }
        if (props.showNewsAgency && ag && ag.length != 0) {
            creditComponent.push(ag)
        }
        let formattedDate = '';
        formattedDate = convertEpochTime(upd, 'updated', 'MMM DD, YYYY, HH:MM TZ') as string;



        if (formattedDate && props.showTimeStamp) {
            creditComponent.push(formattedDate)
        }
        let creditStr = creditComponent.join(" | ")
        return <><span className='articalShowAuthr' dangerouslySetInnerHTML={{ __html: creditStr }} /></>
    }
    // <div className='socialMediaWrap'>
    //     <div className='commonSocialListWrap'>
    //         {
    //             <SocialShareTwo shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL} shareText={podcastShowData.hl} />
    //         }
    //     </div>
    // </div>





    ////console.log('podcastShowData7777', podcastShowData)

    const isDataAvailable = podcastShowData && Object.keys(podcastShowData).length > 0;

    let slikeId = '';

    if (isDataAvailable && podcastShowData.media) {
        if (podcastShowData.media.rmid === 10) {
            slikeId = 'yt' + podcastShowData.media.id;
        } else {
            slikeId = podcastShowData.media.id;
        }

    }

    return (
        <React.Fragment>
            <Grid className="podAcstThemeTwoPodCastShow">
                <Grid item sm={12} xs={12} className='videofullbox'>
                    <div>

                        {
                            typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)) ?
                                <div className="podAcstThemeTwoPodCastBox">
                                    {isDataAvailable && podcastShowData.media &&
                                        <div style={{ position: 'relative' }}>
                                            <img src={`/thumb/110801486.cms?&width=760&height=428&resizemode=75`} alt={podcastShowData?.hl?.slice(0, 25)} title={podcastShowData?.hl?.slice(0, 25)} />

                                        </div>
                                    }

                                </div>
                                :
                                <div>
                                    <MediaPlayerWrapper
                                        containerId={`playerContainer_${slikeId}`}
                                        apiKey="test403web5a8sg6o9ug"
                                        slikeId={slikeId}
                                        Pl_Type='Audio'
                                        autoPlay={true}
                                        skipAd={true}
                                        mute={false}
                                        playInBackground={true}
                                        pipMode={false}
                                    />

                                </div>

                        }


                    </div>
                    {/* Slike ID: 1xvqy7y96l */}
                    {/* Audio: 1xsbjps9ku */}
                    {/* for You Tube: U_S3PoxPHuI, please pass YT_ before youtube ID */}
                </Grid>
                <Grid item md={12}>
                    <div className="podAcstThemeTwoVideoTitle">
                        <Typography className="podAcstThemeTwoStoryHeading" variant='h2'>
                            {podcastShowData && podcastShowData?.hl}
                        </Typography>
                    </div>
                    <Grid container item md={12} position={'relative'} direction="column">
                        <div className='themeTwoVideoWrapAfency'>
                            {showCredits()}
                        </div>
                        {/* {isDataAvailable && getAuthorDetails()} */}
                        {/* {<SocialShare visible={view} />}   */}
                    </Grid>
                    <div className="podAcstThemeTwoPodCastSummery">
                        <Typography>
                            {podcastShowData && podcastShowData.Story}
                        </Typography>

                        <div className='podCastShowAuthorCard'>
                        {authorCard && podcastShowData.authorDetails && Array.isArray(podcastShowData.authorDetails) && podcastShowData.authorDetails.length >= 0 &&
                            podcastShowData.authorDetails.map((authorDetail: any) => (
                                getAuthorCardTwo(props, authorDetail)
                            ))
                        }
                    </div>
                    </div>
                </Grid>

                <Grid container direction="row" className='tag_dnone'>
                    <Grid item sm={12}>
                        {podcastShowData && showTags && podcastShowData.pubInfo && <Tag baseDomain={podcastShowData.pubInfo.baseDomain} tagsData={podcastShowData.kws} anchorLinksValue={anchorLinksValue} />}
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
